var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _c("input", {
      staticClass: "slider mb-4",
      attrs: {
        type: "range",
        min: "-1",
        max: "1",
        step: "0.01",
        "data-toggle": "tooltip",
        "data-html": "true",
        "data-placement": "bottom",
        disabled: !_vm.isEnabled
      },
      domProps: { value: _vm.veracity },
      on: {
        input: function($event) {
          _vm.$emit("input", Number($event.target.value))
        }
      }
    })
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-4 text-left" }, [_vm._v("False")]),
      _vm._v(" "),
      _c("div", { staticClass: "col-4 text-center" }, [_vm._v("Undecided")]),
      _vm._v(" "),
      _c("div", { staticClass: "col-4 text-right" }, [_vm._v("True")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }